import { AuthenticationErrorCommon } from '../../common/errors.js';
/**
 * Errors for the `BCH_2023_05` instruction set.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const AuthenticationErrorBch2023 = AuthenticationErrorCommon;
//# sourceMappingURL=bch-2023-errors.js.map